import { useState } from 'react';
import { useAuth } from '../context/AuthContext';

const COUNTRIES = ['Uganda','Kenya','Nigeria','Ghana','Ethiopia','Tanzania','South Africa','Senegal','Rwanda','Cameroon','DR Congo','Zimbabwe','Zambia','Angola','Egypt','Morocco','Other'];

export default function AuthPage() {
  const { loginWithGoogle, loginWithEmail, registerWithEmail } = useAuth();
  const [mode, setMode] = useState('login');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [form, setForm] = useState({ email: '', password: '', displayName: '', country: 'Uganda' });
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  async function handleSubmit(e) {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      if (mode === 'login') await loginWithEmail(form.email, form.password);
      else {
        if (!form.displayName.trim()) { setError('Display name required'); setLoading(false); return; }
        await registerWithEmail(form.email, form.password, form.displayName, form.country);
      }
    } catch (err) {
      setError(err.message.replace('Firebase: ','').replace(/\(auth\/.*\)/,'').trim());
    } finally { setLoading(false); }
  }

  async function handleGoogle() {
    setError(''); setLoading(true);
    try { await loginWithGoogle(); }
    catch (err) { setError(err.message); }
    finally { setLoading(false); }
  }

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'var(--night)', backgroundImage:'radial-gradient(ellipse at 20% 50%, rgba(232,168,56,0.08) 0%, transparent 60%), radial-gradient(ellipse at 80% 20%, rgba(201,75,48,0.08) 0%, transparent 60%)', padding:20 }}>
      <div style={{ width:'100%', maxWidth:420, background:'var(--earth)', border:'1px solid var(--border)', borderRadius:20, padding:'36px 32px' }}>
        <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:28 }}>
          <div style={{ width:48, height:48, borderRadius:14, background:'linear-gradient(135deg, var(--sunset), var(--flame))', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:'Sora,sans-serif', fontSize:24, fontWeight:700, color:'white' }}>U</div>
          <div>
            <div style={{ fontFamily:'Sora,sans-serif', fontSize:22, fontWeight:700 }}>Umo<span style={{ color:'var(--sunset)' }}>ja</span></div>
            <div style={{ fontSize:12, color:'var(--muted)' }}>Africa's Social Platform 🌍</div>
          </div>
        </div>

        <form onSubmit={handleSubmit} style={{ display:'flex', flexDirection:'column', gap:14 }}>
          {mode === 'register' && <>
            <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
              <label style={{ fontSize:12, color:'var(--muted)', fontWeight:500 }}>Display Name</label>
              <input type="text" placeholder="Your name" value={form.displayName} onChange={e => set('displayName', e.target.value)} required style={{ padding:'11px 14px', borderRadius:10, fontSize:14 }} />
            </div>
            <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
              <label style={{ fontSize:12, color:'var(--muted)', fontWeight:500 }}>Country</label>
              <select value={form.country} onChange={e => set('country', e.target.value)} style={{ padding:'11px 14px', borderRadius:10, fontSize:14 }}>
                {COUNTRIES.map(c => <option key={c}>{c}</option>)}
              </select>
            </div>
          </>}
          <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
            <label style={{ fontSize:12, color:'var(--muted)', fontWeight:500 }}>Email</label>
            <input type="email" placeholder="you@example.com" value={form.email} onChange={e => set('email', e.target.value)} required style={{ padding:'11px 14px', borderRadius:10, fontSize:14 }} />
          </div>
          <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
            <label style={{ fontSize:12, color:'var(--muted)', fontWeight:500 }}>Password</label>
            <input type="password" placeholder="••••••••" value={form.password} onChange={e => set('password', e.target.value)} required minLength={6} style={{ padding:'11px 14px', borderRadius:10, fontSize:14 }} />
          </div>
          {error && <div style={{ fontSize:12, color:'#f87171', padding:'8px 12px', background:'rgba(248,113,113,0.1)', borderRadius:8 }}>{error}</div>}
          <button type="submit" disabled={loading} style={{ padding:'12px', borderRadius:30, background:'linear-gradient(135deg, var(--sunset), var(--flame))', color:'white', border:'none', fontSize:14, fontWeight:500, cursor:'pointer' }}>
            {loading ? '...' : mode === 'login' ? 'Sign In' : 'Create Account'}
          </button>
          <div style={{ display:'flex', alignItems:'center', gap:10 }}>
            <div style={{ flex:1, height:1, background:'var(--border)' }} />
            <span style={{ fontSize:12, color:'var(--muted)' }}>or</span>
            <div style={{ flex:1, height:1, background:'var(--border)' }} />
          </div>
          <button type="button" onClick={handleGoogle} disabled={loading} style={{ padding:'12px', borderRadius:30, background:'transparent', color:'var(--text)', border:'1px solid var(--border)', fontSize:14, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:8 }}>
            <svg width="16" height="16" viewBox="0 0 24 24"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/></svg>
            Continue with Google
          </button>
        </form>
        <div style={{ textAlign:'center', marginTop:20, fontSize:13, color:'var(--muted)' }}>
          {mode === 'login'
            ? <span>No account? <button onClick={() => setMode('register')} style={{ background:'none', border:'none', color:'var(--sunset)', fontSize:13, fontWeight:500, cursor:'pointer' }}>Sign up</button></span>
            : <span>Have account? <button onClick={() => setMode('login')} style={{ background:'none', border:'none', color:'var(--sunset)', fontSize:13, fontWeight:500, cursor:'pointer' }}>Sign in</button></span>
          }
        </div>
      </div>
    </div>
  );
}
